import map from 'lodash/map';
import each from 'lodash/each';
import filter from 'lodash/filter';

export const currentCampaignUpsellIds = state => {
  return map(state.currentCampaign.upsellData.upsells, currentUpsell => currentUpsell.campaign_id);
};

export const productVariants = state => {
  let variants = 0;

  each(state.currentCampaign.firstProductsWithColors, product => {
    if (product.is_active && !product.is_discontinued) {
      let createdColors = filter(product.colors, color => color.created),
        newColors = filter(product.colors, color => !color.created && color.active);

      variants += createdColors ? createdColors.length : 0;
      variants += newColors ? newColors.length : 0;
    }
  });

  return variants;
};

export const visitorDevices = state => map(state.aggregations.visitorDevices, device => device);

export const visitorReferrals = state => map(state.aggregations.visitorReferrals, (referral, key) => { return { ...referral, source: key }; });